import React, { useState, useEffect } from 'react';
import { useMaintenanceModel } from "../maintenanceModel";
import { YhPrintSa } from "@/components/YHPrintSa";
import { maintenanceService } from '../maintenanceService';
import { IItemDetailList, IMaterialDetailList, IMaintenanceDetail } from '../maintenanceTypes';
import { formatNum, formatIntPoint, numberParseChina } from '@/utils/utils';
import moment from 'moment';
import useGlobalModel from '@/model/globalModel';
import zh_CN from '@/locale/zh-CN';
import en_US from '@/locale/en-US';
import { useDictModel } from '@/views/base/dict/dictModel';
export type IMaintenanceAndItemType = {
    total: number
    discount: number
}

export function PrintSa() {
    const initDesc = { total: 0, discount: 0 }
    const { print, setPrint, onPrinting, selectedRow } = useMaintenanceModel();
    const [formVal, setFormVal] = useState<IMaintenanceDetail>();
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IMaintenanceAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IMaintenanceAndItemType>(initDesc);
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { getTreeNodeOne } = useDictModel();

    const { CustomerData, technicianData, vehicleData, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    useEffect(() => {
        print && getPoDetailOne()
    }, [print])

    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await maintenanceService.one(selectedRow.maintenanceCode as string);
        let { itemDetails, materialDetails, ...formVal } = retData;
        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }

        let newItemDetails = itemDetails?.map((item, index) => {
            newItemTotal.total += Number(item.workHour) * Number(item.price)
            newItemTotal.discount = item.discountRate as number
            return {
                ...item,
                No: index + 1,
                notAmount: formatNum(Number(item.workHour) * Number(item.price))
            }
        })
        let newMaterialDetails = materialDetails?.map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate as number
            return {
                ...item,
                No: index + 1,
                notAmount: formatNum(Number(item.num) * Number(item.price))
            }
        })
        if (retData) {
            console.log(newItemTotal)
            setMaintenanceList(newMaterialDetails as IMaintenanceDetail[] ?? []);
            setItemList(newItemDetails as IMaintenanceDetail[] ?? []);
            setFormVal(formVal)
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };

    const columns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            // title: 'PART NO零件号 رقم القطع',
            title: 'PART NO رقم القطع',
            dataIndex: 'materialCode',
        },
        {
            // title: 'Description零件名称 أسم القطع ',
            title: 'Description أسم القطع ',
            dataIndex: 'materialNameEn',
        },
        {
            // title: 'Quantity数量 كيمة  ',
            title: 'Quantity كيمة  ',
            dataIndex: 'num',
        },
        {
            // title: 'Unit price单价  SR أسعار ',
            title: 'Unit price SR أسعار ',
            dataIndex: 'price',
        },
        {
            // title: ' Amount总价 أجمالي ',
            title: ' Amount أجمالي ',
            dataIndex: 'notAmount',
        }
    ]
    //商品
    const columsAlb = [
        {
            title: 'الاجمالي',
            dataIndex: 'notAmount',
        },
        {
            title: 'سعر الوحدة',
            dataIndex: 'price',
        },
        {
            title: 'الكمية',
            dataIndex: 'num',
        },
        {
            title: 'الوحدة',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'اسم الصنف',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'رقم الصنف',
            dataIndex: 'materialCode',
            // colspan: 2
        },
    ]
    const columsEn = [
        {
            title: 'Subtotal',
            dataIndex: 'notAmount',
        },
        {
            title: 'Unit Price',
            dataIndex: 'price',
        },
        {
            title: 'Quantity',
            dataIndex: 'num',
        },
        {
            title: 'Unit',
            dataIndex: 'unitNameEn',
        },
        {
            title: 'Item',
            dataIndex: 'materialNameEn',
        },
        {
            title: 'Item Code',
            dataIndex: 'materialCode',
            // colspan: 2
        },
    ]
    const itemClumns = [
        {
            title: 'No',
            dataIndex: 'No',
        },
        {
            // title: '项目编码',
            title: 'Item Code رمز العناصر',
            dataIndex: 'itemCode',
        },
        {
            // title: '项目名称',
            title: 'Item  اسم العناصر',
            dataIndex: 'itemNameEn',
        },
        {
            // title: '工时',
            title: 'Man-hours ساعات العمل',
            dataIndex: 'workHour',
        },
        {
            // title: 'Unit price单价  SR أسعار ',
            title: 'Unit price SR أسعار ',
            dataIndex: 'price',
        },
        {
            // title: ' Amount总价 أجمالي ',
            title: ' Amount أجمالي ',
            dataIndex: 'notAmount',
            colspan: 2
        }
    ]
    //项目
    const itemClumnsEn = [
        {
            title: 'Labour',
            dataIndex: 'notAmount',
        },
        {
            title: 'Quantity',
            dataIndex: 'workHour',
        },
        {
            title: 'Unit Price',
            dataIndex: 'price',
        },
        {
            title: 'Item',
            dataIndex: 'itemNameEn',
            colspan: 2
        },
        {
            title: 'Item Code',
            dataIndex: 'itemCode',
        },
    ]
    const itemClumnsAlb = [
        {
            title: 'اجمالي الأجور',
            dataIndex: 'notAmount',
        },
        {
            title: 'الكمية',
            dataIndex: 'workHour',
        },
        {
            title: 'سعر الوحدة',
            dataIndex: 'price',
        },
        {
            title: 'وصف الخدمة',
            dataIndex: 'itemNameEn',
            colspan: 2
        },
        {
            title: 'رقم الصنف',
            dataIndex: 'itemCode',
            // colspan: 2
        }
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "Date:",
                fieldValue: moment(formVal?.createTime).format("YYYY/MM/DD"),
                fieldLabelAlb: 'التاريخ:'
            },
            {
                fieldLabel: "Customer Name:",
                fieldValue: formVal?.customerName,
                fieldLabelAlb: 'اسم العميل'
            },
            {
                fieldLabel: "Bus No:",
                fieldValue: formVal?.licensePlate,
                fieldLabelAlb: 'رقم الحافلة:'
            },
            {
                fieldLabel: "Type:",
                fieldValue: getTreeNodeOne(formVal?.payType as string)[0]?.nameEn as string ?? '',
                fieldLabelAlb: 'نوع الفاتوره:'
            },
            {
                fieldLabel: "Invoice No:",
                fieldValue: `NOR${formVal?.maintenanceCode?.slice(5)}`,
                fieldLabelAlb: 'رقم الفاتورة'
            },
            {
                fieldLabel: "Customer Vat No:",
                fieldValue: '',
                fieldLabelAlb: 'الرقم الضريبي للعميل',
                className: " border-bootom"
            },
        ],
        footer: [
            {
                fieldLabel: "Prepared اعداد",
                fieldValue: ""
            },
            {
                fieldLabel: "Customer العميل",
                fieldValue: ""
            },
        ],
        totalAmount: [
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true,
                className: 'bd-none',
            },
            {
                fieldLabel: "Total Spare Parts",
                fieldValue: maintenanceTotal.total,
                fieldLabelAlb: "اجمالي قطع الغيار ",
                className: 'bd-none',

            },
            {
                fieldLabel: "Discount",
                fieldValue: maintenanceTotal.discount === 100 ? 0 : (100 - maintenanceTotal.discount),
                suffix: "%",
                fieldLabelAlb: "الخصم",
                className: 'bd-none',
            },
            {
                fieldLabel: "Discount Amount",
                fieldValue: maintenanceTotal.total * (maintenanceTotal.discount === 100 ? 0 : (100 - maintenanceTotal.discount) / 100),
                fieldLabelAlb: "الخصم",
                className: 'bd-none',
            },
            {
                fieldLabel: "Net Total ",
                fieldValue: (Number(formVal?.materialScienceAmount) * 1).toFixed(2),
                fieldLabelAlb: "الصافي",
                className: 'bd-none',
            },
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true,
                className: 'bd-none',
            },
            {
                fieldLabel: "Subtotal",
                fieldValue: maintenanceTotal.total + itemTotal.total,
                fieldLabelAlb: "الاجمالي الفاتورة",
                className: 'bd-none',
                // colSpan: [4, 1, 1],
            },
            {
                fieldLabel: "Discount Amount",
                fieldValue: maintenanceTotal.total * (maintenanceTotal.discount === 100 ? 0 : (100 - maintenanceTotal.discount) / 100) + itemTotal.total * (itemTotal.discount === 100 ? 0 : (100 - itemTotal.discount) / 100),
                fieldLabelAlb: "اجمالي الخصم",
                className: 'bd-none',
                // colSpan: [4, 1, 1],
            },
            {
                fieldLabel: "Total",
                fieldValue: Number(formVal?.materialScienceAmount) + Number(formVal?.workingHoursAmount),
                fieldLabelAlb: "الصافي",
                className: 'bd-none',
                // colSpan: [4, 1, 1],
            },
            {
                fieldLabel: "Vat Amount 15 %",
                fieldValue: Number(formVal?.materialScienceAmount) * 0.15 + Number(formVal?.workingHoursAmount) * 0.15,
                fieldLabelAlb: "الضريبة 15%",
                className: 'bd-none',
                // colSpan: [4, 1, 1],
            },
            {
                fieldLabel: "Net Total With Vat",
                fieldValue: (Number(formVal?.receivableTotalAmount) * 1).toFixed(2),
                fieldLabelAlb: "الصافي بعد الضريبة",
                className: 'bd-none',
                // colSpan: [4, 1, 1],
            },
            // {
            //     // fieldLabel:(100 - maintenanceTotal.discount) + "%"+"DISCOUN折扣 الخصم",
            //     fieldLabel: " الخصم DISCOUN " + (100 - maintenanceTotal.discount) + "%",
            //     fieldValue: maintenanceTotal.total - maintenanceTotal.total * (maintenanceTotal.discount / 100),
            //     // suffix: "%"
            // },
            // {
            //     fieldLabel: "TOTAL  اجمالي",
            //     fieldValue: formVal?.materialScienceAmount,
            // },
            // {
            //     fieldLabel: "VAT 15%   الضريبة",
            //     fieldValue: Number(formVal?.materialScienceAmount) * 0.15,
            // },
            // {
            //     fieldLabel: " NET TOTAL  الصافي",
            //     fieldValue: Number(formVal?.materialScienceAmount) + Number(formVal?.materialScienceAmount) * 0.15,
            // },
            // {
            //     fieldLabel: "",
            //     fieldValue: "",
            //     empty: true
            // },
            // {
            //     fieldLabel: "Document amount       مبلغ الوثيقة ",
            //     fieldValue: (Number(formVal?.receivableTotalAmount) * 1).toFixed(2),
            // },
        ],
        itemAmount: [
            {
                fieldLabel: "",
                fieldValue: "",
                empty: true,
                className: 'bd-none',
            },
            {
                fieldLabel: "Total Services",
                fieldValue: itemTotal.total,
                fieldLabelAlb: "اجمالي الخدمات",
                className: 'bd-none',
            },
            {
                fieldLabel: "DISCOUN", //+ (100 - itemTotal.discount) + "%",
                fieldValue: itemTotal.discount === 100 ? 0 : (100 - itemTotal.discount),
                suffix: "%",
                fieldLabelAlb: "الخصم",
                className: 'bd-none',
            },
            {
                fieldLabel: "Discount Amount",
                fieldValue: itemTotal.total * (itemTotal.discount === 100 ? 0 : (100 - itemTotal.discount) / 100),
                fieldLabelAlb: "الخصم",
                className: 'bd-none',
            },
            {
                fieldLabel: "Net Total",
                fieldValue: formVal?.workingHoursAmount,
                fieldLabelAlb: "الصافي",
                className: 'bd-none',
            },
            // {
            //     fieldLabel: "TOTAL  اجمالي",
            //     fieldValue: formVal?.workingHoursAmount,
            // },
            // {
            //     fieldLabel: "VAT 15%   الضريبة",
            //     fieldValue: Number(formVal?.workingHoursAmount) * 0.15,
            // },
            // {
            //     fieldLabel: " NET TOTAL  الصافي",
            //     fieldValue: Number(formVal?.workingHoursAmount) + Number(formVal?.workingHoursAmount) * 0.15,
            // },
        ]
    }
    const onCancel = () => {
        setPrint(false)
        setMaintenanceList([]);
        setItemList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const onConfirm = async () => {
        let { id, maintenanceCode } = selectedRow
        await onPrinting({ id, maintenanceCode })
    }
    return (
        <YhPrintSa
            title=""
            type=""
            pageHeader="Service Invoice فاتورة مبيعات "
            visible={print}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            itemClumns={itemClumns}
            itemDataSource={itemList}
            dataSource={maintenanceList}
            printShow={printShow}
            // formVal={formVal}
            formVal={`رقم الضريبة:301198769900003 شركة نور السيارات المحدودة
            تاريخ：${ moment(formVal?.createTime).format("DD/MM/YYYY HH:MM")}
            ضريبة القيمة المضافة：${formatNum(Number(formVal?.materialScienceAmount) * 0.15 + Number(formVal?.workingHoursAmount) * 0.15)}
            الإجمالي شاملاً ضريبة القيمة المضافة：${formatNum(Number(formVal?.receivableTotalAmount))}`}
            columsAlb={columsAlb}
            columsEn={columsEn}
            itemClumnsAlb={itemClumnsAlb}
            itemClumnsEn={itemClumnsEn}
        />
    );
}

export default PrintSa;
